import styled, { CSSObject } from '@emotion/styled'
import { Button } from '../Controls'
import { LineBreak } from '../Shop/commonStyles'
import { CartBreakdownItem } from '../Cart'
import { StyledHTMLElement } from 'shop/theme/types'
import { ConsumerCart } from 'shop/types/cart'
import DiscountBasketValue from './DiscountBasketValue/DiscountBasketValue'
import PotentialLoyaltyGains from './PotentialLoyaltyGains'
import AnimatedRow from './AnimatedRow'

interface Props {
  cart: ConsumerCart | null
  cartLoading: boolean
  hasCheckoutWarnings: boolean
  checkout: () => void
  ctaCopy: string | React.ReactNode
  isCartMatch: boolean
}

const ShopCartFooter = ({
  cart,
  cartLoading,
  hasCheckoutWarnings,
  checkout,
  ctaCopy,
  isCartMatch
}: Props) => {
  const hasOrderItems = !!cart?.orderItems?.length
  const { summary, potentialLoyaltyGains } = cart || {}
  const { base: subtotal } = summary?.subtotal || {}
  const { deliveryPricingBands } = summary || {}
  const shouldShowSubtotal = isCartMatch && !!parseFloat(subtotal || '0')
  const shouldShowDiscountBasketVal =
    isCartMatch &&
    !!parseFloat(subtotal || '0') &&
    !!deliveryPricingBands?.length
  const showPotentialLoyaltyGains = isCartMatch && !!potentialLoyaltyGains

  return (
    <Actions>
      <LineBreakContainer>
        <LineBreak height={'2px'} />
      </LineBreakContainer>
      <AnimatedRow
        shouldShow={shouldShowSubtotal}
        testId={'animated-row-subtotal'}
      >
        <CartBreakdownItem
          fontWeight={500}
          label={'Subtotal'}
          price={cart?.summary.subtotal}
          isCartLoading={cartLoading}
          withLineBreak={false}
          priceOrientation='horizontal'
          padding={'0 0 8px'}
        />
      </AnimatedRow>
      <AnimatedRow shouldShow={showPotentialLoyaltyGains}>
        <PotentialLoyaltyGains
          potentialLoyaltyGains={
            potentialLoyaltyGains || {
              points: { total: 0 },
              stamps: { total: 0 }
            }
          }
        />
      </AnimatedRow>
      <AnimatedRow shouldShow={shouldShowDiscountBasketVal}>
        <DiscountBasketValue
          cartLoading={cartLoading}
          subtotal={subtotal || '0'}
          deliveryPricingBands={deliveryPricingBands || []}
        />
      </AnimatedRow>
      <Button
        testId='checkout-button'
        onClick={checkout}
        disabled={!hasOrderItems || hasCheckoutWarnings || !isCartMatch}
        borderRadius={'6px'}
        fontWeight={600}
        variant={
          !hasOrderItems || hasCheckoutWarnings || !isCartMatch
            ? 'warning'
            : 'primary'
        }
      >
        {ctaCopy}
      </Button>
    </Actions>
  )
}

const Actions = styled.div(
  (): CSSObject => ({
    padding: '0 0 16px',
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    p: {
      margin: '0'
    }
  })
)

const LineBreakContainer = styled.div<StyledHTMLElement & { margin?: string }>(
  ({ margin = '0 -16px 0px' }) => ({
    margin: margin,
    boxShadow: '0px -5px 12px 1px rgba(0, 0, 0, 0.05)',
    paddingBottom: '12px'
  })
)

export default ShopCartFooter
